export default "__VITE_ASSET__56a9b1c8__"